import {Nullish} from 'shared/web';

import {filterByMinMax} from './filterByMinMax';

const DAYS_IN_ADVERTISEMENT_VALUES = [10, 30, 60, 90];

export const getDaysInAdvertisementOptions = (min?: number | Nullish, max?: number | Nullish) =>
  filterByMinMax(min, max)(DAYS_IN_ADVERTISEMENT_VALUES);
